import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SignIn } from './pages/SignIn';
import { AuthorizeError } from './pages/AuthorizeError';
import { NotFound } from './pages/NotFound';
import { ApproveAuthorization } from './pages/ApproveAuthorization';

function App() {
    return (
        <Routes>
            <Route path='/sign-in' element={<SignIn />} />
            <Route path='/approve' element={<ApproveAuthorization />} />
            <Route path='/authorize-error' element={<AuthorizeError />} />
            <Route path='*' element={<NotFound />} />
        </Routes>
    );
}

export default App;
